import { observer } from "mobx-react";
import { FormField } from "../../../../../components/form-field/form-field";
import { IOption, SelectDropdown } from "../../../../../components/inputs/select-dropdown/select-dropdown";
import { Note, NOTE_TYPE } from "../../../../../components/note/note";
import RmaPageStore, { IRmaApproveAction } from "../../stores/rma-page-store";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import RmaActionChangeReturnMethodConfirm
	from "../rma-action-change-return-method-confirm/rma-action-change-return-method-confirm";
import { SingleValue } from "react-select";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";
import RmaActionModalEmailSection from "../rma-action-modal/rma-action-modal-email-section";
import RmaActionModalLayout from "../rma-action-modal/rma-action-modal-layout";

interface IProps {
	rma: RmaPageStore;
	rmaAction: IRmaApproveAction;
	onCloseClick: () => void;
}

const RmaActionApproveModal: React.FC<IProps> = observer(({rma, rmaAction, onCloseClick}) => {
	const actionStore = rmaAction.store;
	const {getTranslation} = useDashboardTranslation();
	const scope = "dashboard-returns-rma-card";
	const approveRequestScope = "dashboard-approve-request-popup";

	const selectedReturnMethod = rma.returnMethodOptions.find((o) => o.value === actionStore.newReturnMethodId);

	const handleSubmit = () => {
		actionStore.submitAction(() => {
			rmsMixpanelStore.trackEvent("d&_approve_return_button_confirmed");
			onCloseClick();
		});
	};

	const handleDismiss = () => {
		rmsMixpanelStore.trackEvent("d&_rma_keep_current_status");
		onCloseClick();
	};

	const handleReturnMethodChange = (v: SingleValue<IOption>) => {
		actionStore.setNewReturnMethodId(v?.value as number);
	};

	const showReturnMethodChangeModal = (
		actionStore.showReturnMethodChangeWarning &&
		rma.customerCaseStore?.returnLabelFee &&
		rma.rmaReturnMethod
	);

	return (
		<>
			<RmaActionModalLayout
				rmaAction={rmaAction}
				onDismiss={handleDismiss}
				onSubmit={handleSubmit}
				isDisabled={actionStore.isProcessing}
				isLoading={actionStore.isProcessing}
			>
				<RmaActionModalEmailSection
					emailStore={actionStore}
					isDisabled={actionStore.isProcessing}
				/>
				<FormField label={getTranslation("RETURN_METHOD", scope)}>
					<SelectDropdown
						options={rma.returnMethodOptions}
						onChange={handleReturnMethodChange}
						value={selectedReturnMethod}
						disabled={false}
					/>
					{!!actionStore.returnMethodWarning && (
						<Note
							type={NOTE_TYPE.WARNING}
							body={getTranslation(actionStore.returnMethodWarning, approveRequestScope)}
						/>
					)}
				</FormField>
			</RmaActionModalLayout>
			{showReturnMethodChangeModal && (
				<RmaActionChangeReturnMethodConfirm
					returnMethodChangeStore={actionStore}
					returnLabelFeeAmount={rma.customerCaseStore.returnLabelFee}
					paymentCurrencyCode={rma.customerCaseStore.paymentCurrencyCode}
					currentReturnMethodName={rma.returnMethodOptions.find((o) => o.value === rma.rmaReturnMethod?.id)?.label}
					newReturnMethodName={selectedReturnMethod?.label}
					switchToNoShipmentRequired={
						!!rma.noShipmentRequiredReturnMethodId &&
						selectedReturnMethod?.value === rma.noShipmentRequiredReturnMethodId
					}
				/>
			)}
		</>
	);
});

export default RmaActionApproveModal;
